<template>
    <div id="list-category">
        <v-container v-if="categories[data.category_type]">
            <v-row>
                <v-col cols="12">
                    <h3 class="text-h3">{{ data.title }}</h3>
                </v-col>
                <v-col cols="12">
                    <v-row align="center" v-if="categories[data.category_type].length > 1">
                        <v-col cols="12" md="6" lg="4"
                        v-for="(category, index) in categories[data.category_type]"
                        :key="category.slug+'-'+index"
                        >
                        <v-card class="bg-transparent rounded-0 " :to="category.route">
                            <v-row no-gutters align="center">
                                <v-col class="pa-3">
                                    <h3 class="text-primary bold">{{ category.title }}</h3>
                                </v-col>
                                <v-col class="text-end pa-3">
                                    <v-img
                                        :lazy-src="category.logo_white.sizes.thumbnail"
                                        lazy
                                        width="60"
                                        height="60"
                                        data-aos="fade-up"
                                        :src="category.logo_white.sizes.full"
                                        contain
                                        :alt="category.logo_white.title+' - '+category.logo_white.description"
                                        class="mx-auto float-end"
                                    ></v-img>
                                </v-col>
                                <v-col cols="12">
                                    <v-progress-linear height="1" color="primary" model-value="100"></v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
   
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            categories: 'categories/list',
        }),
    },
    data: () => ({
        
    }),
    mounted(){
        if(!this.categories.length){
            if(this.data.categories){
                this.$store.dispatch('categories/setCategories',this.data.categories)
            }else{
                this.getCategories();
            }   
        }
    },
    methods:{
        async getCategories(){
            await this.$store.dispatch('categories/getList');
        }
    }
}
</script>